import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import HttpBackend from "i18next-http-backend"
import { initReactI18next } from 'react-i18next'

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .init({
    debug: false,
    load: 'languageOnly',
    react: {useSuspense: false},
    lng: navigator.language.split('-')[0],
    fallbackLng: "en", // use en if detected lang is not available

    keySeparator: false, // we do not use keys in form messages.welcome
    nsSeparator: false, // nor namespaces... but we want to use colons!

    interpolation: {
      escapeValue: false // not needed for react
    },
    backend: {
      loadPath: import.meta.env.BASE_URL+"locales/{{lng}}/{{ns}}.json"
    },

    // have a common namespace used around the full app
    ns: ["translation"],
    defaultNS: "translation",

    //showSupportNotice: false
  })

export default i18n
